import React, { useEffect } from 'react'
import styled from 'styled-components'
import VideoForm from './VideoForm'
import { useSelector, useDispatch } from 'react-redux'
import { uploadVideo, setViewUploadVideoModal, resetAllLoadingSuccessError, setUploadVideoType } from 'features/videos/videoSlice'
import ModalCloseButton from 'components/buttons/ModalCloseButton'
import SpinnerSmall from 'components/SpinnerSmall'
import VideoUploadSelect from 'components/videos/VideoUploadSelect'
import { IoArrowBack } from "react-icons/io5";
import { pBtn, pBtnSmall } from 'components/main.styled'
import { GoVideo } from "react-icons/go";
import { toast } from 'react-hot-toast'
import { StyledHeading, UploadModalContainer } from 'components/media/media.styled';
import { useTranslation } from 'react-i18next'

export default function UploadVideoModal() {
    const { t } = useTranslation('media')
    
    const dispatch = useDispatch()
    const { isVideoUploading, selectedVideo, isVideoUploadSuccess, uploadVideoType, thumbnailPreview, videoUrl, videoTitle } = useSelector((state) => state.video)
    const { profileChurch } = useSelector((state) => state.profileChurch)

    const handleUpload = () => {

        if(!videoTitle || videoTitle.trim() === ''){
            return toast.error(t('validation.videoTitle'))
        }

        if(uploadVideoType === 'computer'){
            // here we are uploading a video and an image to the database
            const formData = new FormData(); 
            formData.append("churchId", profileChurch._id)
            formData.append("file", selectedVideo)
            formData.append("videoTitle", videoTitle)
            formData.append("videoSource", uploadVideoType)  

            dispatch(uploadVideo(formData))

        }else if(uploadVideoType === 'youtube' || uploadVideoType === 'url'){

            if(!videoUrl || videoUrl.trim() === ''){
                return toast.error(t('validation.videoUrl'))
            }

            // here we are not uploading any files, simply adding URLs to the database
            dispatch(uploadVideo({
                churchId: profileChurch._id,
                videoTitle: videoTitle, 
                videoSource: uploadVideoType,
                imageUrl: thumbnailPreview,
                videoUrl: videoUrl
            }))
        }
    }

    useEffect(() => {
        if(isVideoUploadSuccess){
            dispatch(resetAllLoadingSuccessError())
            dispatch(setViewUploadVideoModal(false))
        }
    }, [isVideoUploadSuccess])

    const handleBack = () => {
        dispatch(setUploadVideoType(null)) 
    }

    return (
        <UploadModalContainer>
            <ModalCloseButton
                handler={() => dispatch(setViewUploadVideoModal(false)) }
                size='30px'
                top='10px'
                right='10px' 
                />

            <StyledHeading>
                <GoVideo size={24} /> 
                <span>{t('videoUpload')}</span>
            </StyledHeading>

            {
                uploadVideoType === null ? (
                    <VideoUploadSelect />
                )
                :
                (
                    <div style={{width: '100%'}}>
                        <StyledVBtn onClick={handleBack}><IoArrowBack /> {t('back')}</StyledVBtn>
                        <VideoForm
                            type={uploadVideoType}
                            />
                        <StyledSubmitButton
                            canSubmit={ videoTitle && ( (uploadVideoType === 'computer' && selectedVideo) || ( (uploadVideoType === 'youtube' || uploadVideoType === 'url') && videoUrl ) ) }
                            disabled={isVideoUploading}
                            onClick={handleUpload}
                            >
                            {
                                isVideoUploading ? <SpinnerSmall /> : t('upload')
                            }
                        </StyledSubmitButton>
                    </div>
                )

            } 
        </UploadModalContainer>
    )
}

const StyledVBtn = styled(pBtnSmall)`
    margin-bottom: 10px;
`



const StyledSubmitButton = styled(pBtn)`
    pointer-events: ${props => props.disabled ? 'none' : 'auto'};
    position: absolute;

    bottom: 20px;
    right: 20px;
    width: 100px;
    height: 40px; 
    background-color: ${props => props.canSubmit ? 'var(--themeColor)' : 'grey'};
    color: ${props => props.canSubmit ? 'white' : '#e1e1e1'};
    transition: all 0.3s ease-in-out;
    &:hover{
        background-color: #878787;
    }
`
